<template>
    <div class="inf-pack">
        <div class="title">{{$t('流程图')}}</div>
        <div class="img">
            <img :src="`data:image/png;base64,${imgUrl}`" />
        </div>
        <div class="title">{{$t('处理记录')}}</div>
        <rcTable ref="rcTable"
                 :tableAttr="tableAttr">
        </rcTable>
    </div>
</template>

<script>
import API from '@/service/api'
import rcTable from '@/views/components/basic/rcTable'
export default {
    name: 'Information',
    props: {
        id: {
            required: true
        }
    },
    components: {
        rcTable
    },
    data () {
        return {
            imgUrl: '',
            tableAttr: {
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                pageData: {
                    show: false
                },
                isMultiSelect: false,
                searchShow: false,
                referenceVal: 1200,
                columns: [
                    {
                        title: this.$t('环节'),
                        resizable: true,
                        key: 'activityName',
                        render: (h, { row }) => h('span', { attrs: { title: row.activityName } }, row.activityName)
                    },
                    {
                        title: this.$t('处理人'),
                        key: 'assigneeName',
                        resizable: true,
                        render: (h, { row }) => h('span', { attrs: { title: row.assigneeName } }, row.assigneeName)
                    },
                    {
                        title: this.$t('开始时间'),
                        resizable: true,
                        key: 'startTime',
                        render: (h, { row }) => h('span', { attrs: { title: row.startTime || '--' } }, row.startTime || '--')
                    },
                    {
                        title: this.$t('结束时间'),
                        resizable: true,
                        key: 'endTime',
                        render: (h, { row }) => h('span', { attrs: { title: row.endTime || '--' } }, row.endTime || '--')
                    },
                    {
                        title: this.$t('处理结果'),
                        minWidth: 150,
                        resizable: true,
                        render: (h, { row }) => h('span', { attrs: { title: row.status } }, row.status)
                    }
                ]
            }
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            this.axios.get(this.urlFormat(API.PROCESS_SERVICE_RECORD_ID, true, [this.id])).then(res => {
                const { process, records } = res
                this.imgUrl = process.image
                this.tableAttr.source.tableData = {
                    dataList: records,
                    totalRows: records.length
                }
                this.$refs.rcTable.refreshTable()
            })
        }
    }
}
</script>

<style lang='less' scoped>
.inf-pack {
    .title {
        height: 40px;
        font-size: 12px;
        line-height: 40px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px dashed #e9e9e9;
    }
    .img {
        text-align: center;
        padding-right: 200px;
    }
}
</style>
